import { useMemo } from 'react';

export function useAllPromises<TPromises extends Array<Promise<any>>>(
  ...ps: TPromises
) {
  return useMemo(() => Promise.all(ps), ps);
}
